export default __webpack_public_path__ + "static/media/23.fbe1dd6f.jpg";